export default "__VITE_ASSET__wYMJXPK5__"